import { FC } from 'react'
import { useDispatch } from 'react-redux'

import { addSpecialDay } from '../../../../redux/shifts/shiftsActions'
import { useTypedSelector } from '../../../../redux/store'
import { AddSpecialDayForm } from '../../../containers'
import { SpecialDayFormData } from '../../../entities/SpecialDay/SpecialDay'

export interface ConnectedAddSpecialDayFormProps {
    year: number;
    onClose: () => void;
}

export const ConnectedAddSpecialDayForm: FC<ConnectedAddSpecialDayFormProps> = ({ year, onClose }) => {
    const specialDayTypes = useTypedSelector((state) => state.shiftsReducer.specialDayTypes)

    const dispatch = useDispatch()

    const dispatchAddSpecialDay = (data: SpecialDayFormData) => {
        dispatch(addSpecialDay(data, year))
        onClose()
    }

    return (
        <AddSpecialDayForm
            onSubmit={dispatchAddSpecialDay}
            onCancel={onClose}
            specialDayTypes={specialDayTypes}
        />
    )
}
